export function getFirstFocusIndex(menuItemsState) {
  const {
    menuItems,
    focusOrder
  } = menuItemsState;
  for (let focusIndex = 0; focusIndex < focusOrder.length; focusIndex++) {
    if (!menuItems[focusOrder[focusIndex]].visuallyHidden) {
      return focusIndex;
    }
  }
  return 0;
}
export function getLastFocusIndex(menuItemsState) {
  const {
    menuItems,
    focusOrder
  } = menuItemsState;
  for (let focusIndex = focusOrder.length - 1; focusIndex >= 0; focusIndex--) {
    if (!menuItems[focusOrder[focusIndex]].visuallyHidden) {
      return focusIndex;
    }
  }
  return focusOrder.length - 1;
}
function getLoopedIndex(index, arrLength) {
  if (index >= arrLength) {
    return index % arrLength;
  }
  if (index < 0) {
    return Math.abs(arrLength + index) % arrLength;
  }
  return index;
}
export function getInitialTabIndex(focusOrder, shouldManageTabIndex) {
  if (!shouldManageTabIndex) {
    return undefined;
  }
  return focusOrder.length === 0 ? 0 : -1;
}
export function getNextFocusIndex(menuItemsState, offset, shouldLoopFocus) {
  const {
    menuItems,
    focusOrder,
    currentlyFocused
  } = menuItemsState;
  let nextFocusIndex = currentlyFocused;
  for (let i = 0; i < focusOrder.length; i++) {
    nextFocusIndex = shouldLoopFocus ? getLoopedIndex(nextFocusIndex + offset, focusOrder.length) : nextFocusIndex + offset;
    if (nextFocusIndex < 0 || nextFocusIndex > focusOrder.length - 1) {
      return currentlyFocused;
    }
    if (!menuItems[focusOrder[nextFocusIndex]].visuallyHidden) {
      return nextFocusIndex;
    }
  }
  return currentlyFocused;
}
export function resetMenuItems(menuItemState) {
  const {
    menuItems,
    focusOrder,
    shouldManageTabIndex
  } = menuItemState;
  const updatedMenuItems = Object.assign({}, menuItems);
  focusOrder.forEach((id, index) => {
    updatedMenuItems[id].isFocused = false;
    if (shouldManageTabIndex) {
      updatedMenuItems[id].tabIndex = -1;
      if (index === 0) {
        updatedMenuItems[id].tabIndex = 0;
      }
    }
  });
  return updatedMenuItems;
}
export function updateMenuItems(menuItems, currentlyFocused, shouldManageTabIndex) {
  const updatedMenuItems = Object.assign({}, menuItems);
  Object.keys(updatedMenuItems).forEach(id => {
    if (currentlyFocused === id) {
      if (shouldManageTabIndex) {
        updatedMenuItems[id].tabIndex = 0;
      }
      updatedMenuItems[id].isFocused = true;
      return;
    }
    if (shouldManageTabIndex) {
      updatedMenuItems[id].tabIndex = -1;
    }
    updatedMenuItems[id].isFocused = false;
  });
  return updatedMenuItems;
}